import CONFIG from '@/config/siteConfig';

const HER_NAME = CONFIG.recipientName;
const MY_NAME = CONFIG.senderName;

export const HERO = {
  heading: `For ${HER_NAME}`,
  subtitle: "I made this little place just for us. Just to see you smile and make this special day more special to you",
  button: "Start the journey",
  scrollHint: "Scroll for more",
};

export const LOVE_LETTER = {
  sectionLabel: "Written from the heart",
  heading: "A Letter for You",
  date: "March 22, 2026",
  salutation: `My dearest ${HER_NAME},`,
  paragraphs: [
    "I don't know how you did it, but that was the best 3 years of my life. Everything feels softer, warmer, and more alive.",
    // "‎ ",
    "You're my favorite kind of comfort. The kind that makes the world quiet, the kind that makes even a random day feel like something worth remembering.",
    // "‎ ",
    "I love you for the big things and the tiny ones .. the way you laugh, the way you care, the way you look, the way you think, the way you understand me, the way you make my day x1,000 times better, and most important .. the way you make me laugh",
    "(for the athots and napools too moheheheh :3)",
    "I love you so fucking much, you're the best thing that ever happened to me .. THE BEST",
    `If this website is a little extra… it's because you're worth extra. Always. Happy Birthday, my ${HER_NAME}. `,
  ],
  closing: "Forever yours,",
};

export const REASONS_SECTION = {
  allRevealedText: `...and a million more, ${HER_NAME}`,
};

export const REASONS = [
  { icon: "heart", text: "Your beautiful face that lights up my entire world" },
  { icon: "music", text: "How your laugh is my absolute favorite sound on earth" },
  { icon: "message", text: "Our conversations that I never, ever want to end" },
  { icon: "sparkles", text: "How your pink color makes me want to mix it with my white :p" },
  { icon: "star", text: "Your amazing body and curves 🫦", featured: true },
  { icon: "sun", text: "You're my daily sunshine (even when you act like you're not)." },
  { icon: "zap", text: "Your sense of humor, you make me laugh even on my worst days" },
  { icon: "shield", text: "With you I feel safe, calm, and exactly where I should be." },
  { icon: "infinity", text: "The way you love .. endlessly, fearlessly, and deeply" },
  { icon: "infinity", text: "The smooth-as-silk soft thighs" },
  { icon: "infinity", text: "The rounded-pinkiest boobies I always wanted to thuck" },
  { icon: "infinity", text: "The thickest ass I always wanted to ride and eat (i should stop im getting hard by just thinking of it)" },

];

export const CONTRACT = {
  heading: "Official Love Contract",
  partyIntro: "This agreement is entered into by and between",
  partyLabel: "The Lovers",
  requiredToSign: 14,
  signButton: "Sign with Love",
  signer1Label: "The One Who Loves",
  signer2Label: "The One Who is Loved",
  clauses: [
    {
      section: "Daily Devotions",
      items: [
        "Unlimited hugs on request .. no exceptions",
        "Random \"I miss you / I love you\" messages the whole day",
        "Making you laugh at least once every single day",
        "Good morning texts, even on lazy Sundays",
      ],
    },
    {
      section: "Sacred Promises",
      items: [
        "Always on your side, even when you're wrong (we'll discuss later)",
        "Respect + kindness, always and forever",
        "Listening with my whole heart when you need to talk",
        "Never going to bed angry at each other, we talk, then we hug",
        "Cuddle sessions that \"accidentally\" become makeout breaks",
        "Bedtime routine: one last kiss that turns into \"five more\"",
      ],
    },
    {
      section: "Adventure Clause",
      items: [
        "You get princess treatment: snacks, compliments, and attention",
        "Neck kisses on request (and sometimes unrequested)",
        "To celebrate you and be proud of you",
        "Choosing you, every single day, without hesitation"
      ],
    },
  ],
};

export const HUG = {
  heading: `Send ${MY_NAME} a Hug`,
  subtitle: "Every tap sends a little warmth his way",
  deliveredText: `Hug delivered to ${MY_NAME}`,
  tapHint: "Tap the heart",
  milestones: [
    { at: 1, label: "First hug!" },
    { at: 2, label: "Tiny squeeze unlocked" },
    { at: 3, label: "Getting warmer…" },
    { at: 4, label: "Cuddle mode activated" },
    { at: 5, label: "Bear hug unlocked!" },
    { at: 6, label: "Snuggle streak" },
    { at: 7, label: "Okayyy you're spoiling him" },
    { at: 8, label: `${HER_NAME} is glowing!` },
    { at: 9, label: "Hug legend status" },
    { at: 10, label: "Infinite love mode" },
  ],
};

export const SCRATCH_CARD = {
  sectionLabel: "A little secret, just for you",
  heading: "Scratch to Reveal",
  ticketLabel: "Certified Cute Pass",
  ticketNumber: "#0321",
  hiddenMessage: `Even on the hard days… I'll be the hardest, just for you. Still hard for you. Always hard for you :ppp`,
  scratchHint: "Use finger or mouse",
  revealedLabel: "Message unlocked!",
};

export const COMPLIMENTS = [
  { text: "Your personality is the kind you don't find twice", tag: "flirty" },
  { text: "Every time you say my name, I melt a little .. it's unfair", tag: "flirty" },
  { text: "Your voice is the best thing I've ever heard .. it flips my whole mood", tag: "sweet" },
  { text: "Your face is genuinely stunning .. like I catch myself staring and forgetting what I was about to say.", tag: "flirty" },
  { text: "Your eyes are the type you get lost in .. way too pretty.", tag: "poetic" },
  { text: "Your lips should come with a warning label .. one look and I'm already thinking about a kiss.", tag: "spicy" },
  { text: "Your body is art .. not just sexy, but perfectly *you* .. and I love every detail (especially the pinkest boobies and the thickest ass 🫦).", tag: "spicy" },
  { text: "Your curves are my favorite kind of distraction .. I'm trying to behave, but you make it hard.", tag: "spicy" },
  { text: "Your kisses hit different .. soft, addictive, and they leave me smiling like an idiot.", tag: "spicy" },
  { text: "Loving you feels like a flex .. I'm proud to be yours, and grateful you're mine.", tag: "classic" },
];

export const COMPLIMENT_SECTION = {
  sectionLabel: "Words I mean, every time",
  heading: `Compliments for ${HER_NAME}`,
  button: "Give me one",
  nextButton: "Next compliment",
  allDoneButton: "That's all… for now!",
  autoPlayLabel: "Auto",
  counterSuffix: `of ${COMPLIMENTS.length}`,
};

export const SONG = {
  title: "You Overwhelm Me",
  artist: "Copperplate",
  src: "/music/you-overwhelm-me.mp3",
};

export const PLAYLIST = {
  sectionLabel: "The soundtrack to us",
  heading: "A song that reminds me of you",
  dedication: `Every word of this song was written about ${HER_NAME}`,
  footerText: "Press play… and come a little closer",
};

export const SURPRISE = {
  sectionLabel: "Something special for you",
  heading: "A Little Surprise",
  tapHint: "Tap to unwrap",
  gifts: [
    { id: "nitro", label: "Gift #1", description: "A little upgrade for someone who deserves extra sparkle, Now your profile, messages, and everything in between get to feel a bit more special.", color: "#f48fb1ff", claimUrl: "https://discord.gift/emmNZQDf5xMG5nP3", claimText: "Claim" },
    { id: "spotify", label: "Gift #2", description: "This is a collection of feelings, memories, and songs that reminded me of you .. I hope it becomes one of your favorite little things.", color: "#f48fb1ff", claimUrl: "https://open.spotify.com/playlist/5cTZEtLbdJEmjlk3LXwdP6?si=93741c2709d947bb", claimText: "Listen" },
    { id: "steam", label: "Gift #3", description: "A little something for your next favorite game, You get to choose whatever makes you happiest, and that’s what makes it fun.", color: "#f48fb1ff", code: "I5FBA-M2ZZY-PH7B0" },
    { id: "video", label: "Gift #4", description: "A little video I put together — press play and smile for me", color: "#f48fb1ff", videoSrc: "/birthday-video.mp4" },
    { id: "lilies", label: "Gift #5", description: "Lilies, because you deserve flowers that are almost as pretty as you", color: "#f48fb1ff", lilyLabel: "Since i couldn't get you real lilies, here's some virtual ones" },
  ],
};

export const PORTRAITS = {
  sectionLabel: "Moments worth keeping",
  heading: "Our Little Gallery",
  photos: [
    { id: "1", src: "/gallery/Ashen_One.png", caption: "My beautiful Ashen one" },
    { id: "2", src: "/gallery/tarnished.png", caption: "Laying down with my Elden Lord" },
    { id: "3", src: "/gallery/tarnished2.png", caption: "My Elden Lord and I, chilling at the grace" },
    { id: "4", src: "/gallery/tarnished3.png", caption: "Sitting by the lake with her majesty sitting in my lap" },
    { id: "5", src: "/gallery/Split_fiction.png", caption: "Drawing hearts in Split Fiction" },
    { id: "6", src: "/gallery/SplitFiction2.png", caption: "Swinging together in Split Fiction" },
    { id: "7", src: "/gallery/minecraft.png", caption: "The best house i've ever seen my whole life, my dream house made by my dream girl (Noni and Joud's House)" },
  ],
};

export const BIRTHDAY_WISHES = {
  sectionLabel: "Birthday wishes from your favorites",
  heading: "They Have Something to Say",
  wishes: [
    { id: "leon", name: "Leon S. Kennedy", initials: "LK", color: "#4A6FA5", avatar: "/avatars/leon.jpg", message: "Happy birthday. Stay sharp out there… and try not to get into too much trouble. I'll handle the rest." },
    { id: "ada", name: "Ada Wong", initials: "AW", color: "#C62828", avatar: "/avatars/ada.jpg", message: "Happy birthday, beautiful .. you make every room more dangerous in the best possible way. Stay irresistible, stay unforgettable… and tonight, let the world chase us for once." },
    { id: "ethan", name: "Ethan Winters", initials: "EW", color: "#5D4037", avatar: "/avatars/ethan.jpg", message: "Happy birthday! After everything I've been through, trust me — enjoy every single moment. You deserve it." },
    { id: "kisuke", name: "Kisuke Urahara", initials: "KU", color: "#2E7D32", avatar: "/avatars/urahara.jpg", message: "Oh my, happy birthday~! I'd offer you a special deal from the shop, but the best gift is already here — you!" },
    { id: "rukia", name: "Rukia Kuchiki", initials: "RK", color: "#7B1FA2", avatar: "/avatars/rukia.jpg", message: "Happy birthday. May your heart stay strong and your spirit never waver. I'm proud of you." },
    { id: "mrx", name: "MR. X", initials: "X", color: "#37474F", avatar: "/avatars/mrx.jpg", message: "…" },
    { id: "ichigo", name: "Ichigo Kurosaki", initials: "IK", color: "#E65100", avatar: "/avatars/ichigo.jpg", message: "Yo, happy birthday! I'll protect your smile today — no hollows allowed near your party." },
    { id: "arthur", name: "Arthur Morgan", initials: "AM", color: "#795548", avatar: "/avatars/arthur.jpg", message: "Happy birthday, partner. The world's a rough place, but today? Today's yours. Make it count." },
    { id: "ranni", name: "Ranni the Witch", initials: "R", color: "#1565C0", avatar: "/avatars/ranni.jpg", message: "A most joyous birth anniversary unto thee. May the stars guide thy path for another year." },
    { id: "melina", name: "Melina", initials: "M", color: "#F9A825", avatar: "/avatars/melina.jpg", message: "Happy birthday, Tarnished. I offer you an accord… let today be filled with grace and warmth." },
    { id: "firekeeper", name: "Fire Keeper", initials: "FK", color: "#FF6F00", avatar: "/avatars/firekeeper.jpg", message: "Happy birthday, dear one. May the flame within you never fade, and may this day bring you peace." },
    { id: "sweedah", name: "Sweedah", initials: "SW", color: "#000000ff", avatar: "/avatars/sweedah.png", message: "Meow meow meow meow .. meow meow, meow!" },
  ],
};

export const RUNAWAY_QUESTION = {
  sectionLabel: "Just to make sure",
  heading: `Do you promise to spoil me with athot, napool, thighs, and your face?`,
  subtitle: "(Choose wisely .. that's a promise!)",
  yesButton: "Yes daddy!",
  noButton: "Nah uh",
  celebration: {
    // emoji: "🥰",
    message: "I knew you love me this much!",
    submessage: `(im checking my instagram rn :p)`,
  },
};

export const BIG_QUESTION = {
  heading: `Will you be my Valentine, ${HER_NAME}?`,
  subtitle: "(There's really only one right answer)",
  yesButton: "Yes!",
  absolutelyButton: "YES YES",
  noTexts: ["Hmm...", "Are you sure?", "Really?!", "Think again...", "Nope, try again!", "Not an option!", "Nice try!", "Come on...", "Wrong button!"],
  dodgeHints: [
    "The 'no' button seems to be running away...",
    "It's getting harder to say no!",
    "Just say yes already!",
  ],
  celebration: {
    title: "YAY!",
    subtitle: "Okayyyy my heart is happy.",
    message: `I love you, ${HER_NAME}`,
    hint: "",
  },
  starResponses: [
    null,
    { text: "Only 1 star?! I'm not mad… just disappointed.", emoji: "" },
    { text: "Two stars? I clearly need to try harder next year.", emoji: "" },
    { text: "Three stars… okay, average? I'll take it. Barely.", emoji: "" },
    { text: "Four stars! So close to perfection… what did I miss?!", emoji: "" },
    { text: "Five stars?! I KNEW IT. Best birthday ever, confirmed.", emoji: "" },
  ],
};

export const FOOTER = {
  subtitle: "For the most amazing person in the world",
  easterEggTrigger: "psst...",
  easterEggMore: "tell me more...",
  easterEggMessages: [
    "I wrote this entire website just to make you smile.",
    "Every pixel was placed with love.",
    "You're the reason this exists.",
    `${HER_NAME}, you make everything better.`,
    "This is just the beginning of our story.",
  ],
};

// ════════════════════════════════════════════════════════════════════
//  SECTION ORDER — Reorder, remove, or add sections here.
//  Just move lines up/down to change what appears first.
//  Comment out a line to hide that section entirely.
//
//  Available section IDs:
//    'love-letter'    — The birthday love letter
//    'reasons'        — Reasons I love you grid
//    'love-contract'  — Official love contract
//    'virtual-hug'    — Tap-to-hug heart
//    'scratch-card'   — Scratch to reveal message
//    'compliments'    — Compliment generator
//    'portrait-gallery' — Photo gallery
//    'mini-surprise'  — Gift cards (Nitro, Spotify, video, lilies)
//    'birthday-wishes'— Character birthday messages
//    'runaway-question'— "Do you love me?" with runaway No button
//    'big-question'   — Rate your birthday (stars)
// ════════════════════════════════════════════════════════════════════
export const SECTION_ORDER = [
  'reasons',
  'love-contract',
  'virtual-hug',
  'scratch-card',
  'compliments',
  'portrait-gallery',
  'birthday-wishes',
  'love-letter',
  'mini-surprise',
  'runaway-question',
  'big-question',
];

export { HER_NAME, MY_NAME };
